/**
 * 供应商资料
 */

import request from '@/utils/request'

//商家入驻申请列表
export function getAuditList (params) {
  return request({
    url: '/mch/data/auditlist',
    method: 'get',
    params: params
  })
}

//获取供应商资质详情
export function getAuditDetail (params) {
  return request({
    url: '/mch/data/auditdetail',
    method: 'get',
    params: params
  })
}

//获取店铺申请列表
export function getShopList (params) {
  return request({
    url: '/mch/data/shoplist',
    method: 'get',
    params: params
  })
}

//获取店铺详情
export function getShopDetail (params) {
  return request({
    url: '/mch/data/shopdetail',
    method: 'get',
    params: params
  })
}

//获取身份证信息
export function getIdCardDetail (params) {
  return request({
    url: '/mch/data/getIdCardInfoDetail',
    method: 'get',
    params: params
  })
}

//获取营业执照信息
export function getBusinessInfoDetail (params) {
  return request({
    url: '/mch/data/getBusinessDetail',
    method: 'get',
    params: params
  })
}

//获取银行卡信息
export function getBankCardDetail (params) {
  return request({
    url: '/mch/data/getBankCardInfoDetail',
    method: 'get',
    params: params
  })
}

//商家入驻申请
export function auditApply (data) {
  return request({
    url: '/mch/data/apply',
    method: 'put',
    data: data
  })
}


//店铺审核
export function shopAudit (data) {
  return request({
    url: '/mch/data/shopaudit',
    method: 'put',
    data: data
  })
}

//商家入驻审核
export function mchtaudit (data) {
  return request({
    url: '/mch/data/mchtaudit',
    method: 'put',
    data: data
  })
}

//商家入驻审核 --新的接口
export function doApply (data) {
  return request({
    url: '/mch/data/doApply',
    method: 'put',
    data: data
  })
}

//获取当前登录供应商审核信息
export function getAuditInfo () {
  return request({
    url: '/mch/data/getInfo',
    method: 'get'
  })
}

//获取当前登录供应商审核信息
export function getShopInfo () {
  return request({
    url: '/mch/data/getShopInfo',
    method: 'get'
  })
}

//获取当前登录供应商档口信息
export function stallPosition () {
  return request({
    url: '/mch/data/stallPosition',
    method: 'get'
  })
}

//获取退保证金信息
export function refundInfo () {
  return request({
    url: '/mch/data/refundInfo',
    method: 'get'
  })
}

//获取退保证金申请
export function applyRefund (params) {
  return request({
    url: '/mch/data/applyRefund',
    method: 'get',
    params:params
  })
}

//获取当前登录供应商审核信息
export function getPayAuditLog (params) {
  return request({
    url: '/mch/data/auditLog',
    method: 'get',
    params:params
  })
}

//获取当前用户需要缴纳的保证金
export function getNeedPayFunds () {
  return request({
    url: '/mch/data/getNeedPayFunds',
    method: 'get'
  })
}

//获取当前用户提交申请的记录
export function getPayAuditInfo () {
  return request({
    url: '/mch/data/getPayAuditInfo',
    method: 'get'
  })
}
export function getPayAuthAccessLog () {
  return request({
    url: '/mch/data/getPayAuthAccessLog',
    method: 'get'
  })
}


//支付申请资料提交
export function payApplyAudit (data) {
  return request({
    url: '/mch/data/applyPayInfoUpdate',
    method: 'put',
    data: data
  })
}

// 供应商入驻设置列表
export function settleSteps (params) {
  return request({
    url: '/mcht/paramset/list',
    method: 'get',
    params
  })
}

// 入驻查看编辑
export function updateMchtInfo (data) {
  return request({
    url: '/mch/data/updateMchtInfo',
    method: 'post',
    data: data
  })
}

// 店铺商品数
export function shopLittingNum (params) {
  return request({
    url: '/pmsMchtShopInfo/shopLittingNum',
    method: 'get',
    params
  })
}

// 店铺商品数购买记录
export function shopLittingList (params) {
  return request({
    url: '/pmsMchtShopInfo/shopLittingList',
    method: 'get',
    params
  })
}

// 店铺商品数数据字典
export function shopLittingDict (params) {
  return request({
    url: '/pmsMchtShopInfo/shopLittingDict',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/audit.js